export function testimonialSlider() {
    const swiperContainers = document.querySelectorAll('.testimonial-slider-swiper');
    
    if (!swiperContainers.length || typeof Swiper === 'undefined') {
        return;
    }

    swiperContainers.forEach((swiperContainer) => {
        const prevButton = swiperContainer.querySelector('.testimonial-slider__arrow--prev');
        const nextButton = swiperContainer.querySelector('.testimonial-slider__arrow--next');
        const testimonialSection = swiperContainer.closest('.testimonial-slider');
        const popup = testimonialSection?.querySelector('.testimonial-slider__popup');
        const closeBtn = popup?.querySelector('.close-btn');
        
        const slides = swiperContainer.querySelectorAll('.swiper-slide');
        const slideCount = slides.length;
        const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');

        // Clone both slides if there are exactly 2 slides (to make 4 total)
        if (slideCount === 2) {
            slides.forEach((slide) => {
                const clonedSlide = slide.cloneNode(true);
                swiperWrapper.appendChild(clonedSlide);
            });
        }
        // Clone first slide if there are exactly 3 slides
        else if (slideCount === 3) {
            const firstSlide = slides[0];
            const clonedSlide = firstSlide.cloneNode(true);
            swiperWrapper.appendChild(clonedSlide);
        }

        if (swiperContainer.querySelectorAll('.swiper-slide').length > 1) {
            const swiper = new Swiper(swiperContainer, {
    
                spaceBetween: 20,
                loop: true,
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                },
                speed: 2000,
                centeredSlides: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    1366: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                    },
                   
                   
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        centeredSlides: false,
                    }
                }
            });
        }
        // Initialize Swiper
    

        // Popup functionality
        if (popup) {
            // Handle "Read more" link clicks - use event delegation for all links
            swiperContainer.addEventListener('click', (e) => {
                const readMoreLink = e.target.closest('a[href="#"]');
                if (readMoreLink && readMoreLink.textContent.trim() === 'Read more') {
                    e.preventDefault();
                    popup.classList.add('active');
                    document.body.style.overflow = 'hidden';
                }
            });

            // Handle close button
            if (closeBtn) {
                closeBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    popup.classList.remove('active');
                    document.body.style.overflow = '';
                });
            }

            // Close popup when clicking outside the item
            popup.addEventListener('click', (e) => {
                if (e.target === popup) {
                    popup.classList.remove('active');
                    document.body.style.overflow = '';
                }
            });

            // Close popup on Escape key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && popup.classList.contains('active')) {
                    popup.classList.remove('active');
                    document.body.style.overflow = '';
                }
            });
        }
    });
}

